import React, { useRef, useState } from "react";
import FormikSelect from "../../../../Components/Formik/FormikSelect";
import FormikInput from "../../../../Components/Formik/FormikInput";
import { useFormikContext } from "formik";
import { fileToBase64 } from "../../../../utilities/fileToBase64";
import { useLanguage } from "../../../../Components/LangTranslation/LanguageContext";
import { useSession } from "../../../../authentications/SessionContext";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { checkApi } from "../../../../DataApi/onboarding/checkApi";

function CRBannkAccountStep({
  bankOptions,
  toggleVATSwitch,
  isVATAvailable,
  handleCloseLoader,
}) {
  const { setFieldValue, values, errors, touched, setFieldTouched , setFieldError} =
    useFormikContext();
  const fileInputRefCR = useRef();
  const [fileNameCR, setFileNameCR] = useState("");
  const fileInputRefCC = useRef();
  const [fileNameCC, setFileNameCC] = useState("");
  const fileInputRefVC = useRef();
  const [fileNameVC, setFileNameVC] = useState("");
  const { language, translations } = useLanguage();
  const t = translations[language];
  const { sessionInfo } = useSession();
  const { isVTEX } = sessionInfo;

const handleImageUpload = (e, setFile, key) => {
  const file = e.target.files[0];

  if (file) {
    if (file.size > 2 * 1024 * 1024) {
      setFieldError(key, "File size should not exceed 2MB!");
      setFieldTouched(key, true, false);
      return;
    }

    setFile(file.name);
    fileToBase64(file, (_, base64) => {
      setFieldValue(key, base64 || "");

    
      setFieldError(key, "");
      setFieldTouched(key, false); 
    });
  }
};


  const UploadFileButton = ({
    inputRef,
    fileName,
    uploadText,
    setState,
    keyName,
  }) => {
    return (
      <div className="d-grid mb-2">
        <div
          style={{
            border: "1px solid #cbcbcb",
          }}
          role="button"
          onClick={() => inputRef.current.click()}
          className="p-2 px-3  d-flex justify-content-center align-items-center"
        >
          <i className="far fa-file-pdf text-danger me-3 fa-lg"></i>
          {t[uploadText] + "*"} {fileName}
        </div>
        <input
          ref={inputRef}
          onChange={(e) => handleImageUpload(e, setState, keyName)}
          type="file"
          name={keyName}
          hidden
          accept={
            isVTEX
              ? ".pdf"
              : "text/plain,.odp ,.doc, .docx, .xls, .xlsx, .pdf, .csv, .txt, images/*"
          }
        />
        {touched[keyName] && errors[keyName] && (
          <span className="ps-2 error-message">{errors[keyName]}</span>
        )}
      </div>
    );
  };

  return (
    <>
      {/* {sessionInfo.isVTEX && (
      <div
        className="alert alert-primary d-flex align-items-center"
        // style={{
        //   height: 12 + "px",
        //   padding: "9px !important",
        // }}
        role="alert"
      >
        <i className="bi bi-info-circle mx-2"></i>{" "}
        <span>Upload required documents!</span>
      </div>
      )} */}
      {isVTEX && (
        <div className="form-check form-switch my-3" style={{ width: "20%" }}>
          <label
            className="form-check-label text-secondary fw-bold"
            htmlFor="isVAT"
          >
            {t["Is VAT Applicable?"]}
          </label>
          <input
            className="form-check-input mt-1"
            type="checkbox"
            id="isVAT"
            checked={isVATAvailable}
            data-tooltip-id="isVATTooltip"
            data-tooltip-content="Switch it off, if VAT is not applicable!"
            onChange={toggleVATSwitch}
          />
          <ReactTooltip id="isVATTooltip" type="dark" effect="solid" />
        </div>
      )}
      <div
        style={{
          border: "1px solid #cbcbcb",
          borderRadius: "15px",
          borderStyle: "dashed",
        }}
        className="col-12 row me-0 pe-0"
      >
        <div className="col-12 mt-3">
          <h6 className="text-center text-secondary fw-bold">
            {isVTEX
              ? t["Upload required documents in PDF"]
              : t["Upload required document"]}
          </h6>
        </div>
        <div className="d-flex flex-lg-row flex-column my-3 col-12 p-4 justify-content-center align-items-start gap-3">
          <UploadFileButton
            fileName={fileNameCR}
            inputRef={fileInputRefCR}
            keyName="cr"
            setState={setFileNameCR}
            uploadText="Commercial Registration"
          />
          {sessionInfo.isVTEX === true && (
            <UploadFileButton
              fileName={fileNameCC}
              inputRef={fileInputRefCC}
              keyName="cc"
              setState={setFileNameCC}
              uploadText="Chamber of Commerce"
            />
          )}
          {sessionInfo.isVTEX === true && isVATAvailable && (
            <UploadFileButton
              fileName={fileNameVC}
              inputRef={fileInputRefVC}
              keyName="vc"
              setState={setFileNameVC}
              uploadText="VAT Certificate"
            />
          )}
        </div>
      </div>
      {sessionInfo.isVTEX === true && (
        <>
          <div
            className="col-12 mt-3 row me-0 pe-0"
            style={{
              border: "1px dashed rgb(203, 203, 203)",
              borderRadius: "15px",
            }}
          >
            <div className="col-12 mt-3">
              <h6 className="text-center text-secondary fw-bold">
                {t["Commercial Registration Number & Expiration Date"]}
              </h6>
            </div>
            <div className="my-3 col-md-6 col-12">
              <FormikInput
                name="cr_number"
                placeholder={t["Commercial Registration"] + "*"}
                data-tooltip-id="cr_numberTooltip"
                data-tooltip-content={t["Commercial Registration"] + "*"}
              />
              <ReactTooltip id="cr_numberTooltip" type="dark" effect="solid" />
            </div>
            <div className="my-3 col-md-6 col-12">
              <FormikInput
                type="date"
                name="cr_expiry_date"
                onKeyDown={(e) => e.preventDefault()}
                data-tooltip-id="cr_expiry_dateTooltip"
                data-tooltip-content={t["Commercial Registration Expiry"] + "*"}
              />
              <ReactTooltip
                id="cr_expiry_dateTooltip"
                type="dark"
                effect="solid"
              />
            </div>
          </div>

          {isVATAvailable && (
            <div
              className="col-12 row me-0 pe-0 mt-3"
              style={{
                border: "1px dashed rgb(203, 203, 203)",
                borderRadius: "15px",
              }}
            >
              <div className="col-12 mt-3">
                <h6 className="text-center text-secondary fw-bold">
                  {t["VAT Number & Expiration Date"]}
                </h6>
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  name="vat_number"
                  placeholder={t["VAT"] + "*"}
                  data-tooltip-id="vat_numberTooltip"
                  data-tooltip-content={t["VAT"] + "*"}
                />
                <ReactTooltip
                  id="vat_numberTooltip"
                  type="dark"
                  effect="solid"
                />
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  type="date"
                  name="vat_expiry_date"
                  onKeyDown={(e) => e.preventDefault()}
                  data-tooltip-id="vat_expiry_dateTooltip"
                  data-tooltip-content={t["VAT Expiry"] + "*"}
                />
                <ReactTooltip
                  id="vat_expiry_dateTooltip"
                  type="dark"
                  effect="solid"
                />
              </div>
            </div>
          )}
        </>
      )}
      <div
        className="col-12 row me-0 pe-0 my-3"
        style={{
          border: "1px dashed rgb(203, 203, 203)",
          borderRadius: "15px",
        }}
      >
        <div className="col-12 mt-3">
          <h6 className="text-center text-secondary fw-bold">
            {t["Bank Information"]}
          </h6>
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikSelect
            name="bank_id"
            placeholder={t["Bank Name"] + "*"}
            options={bankOptions}
            data-tooltip-id="bank_idTooltip"
            data-tooltip-content={t["Bank Name"] + "*"}
          />
          <ReactTooltip id="bank_idTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="branch_name"
            placeholder={t["Bank Branch"] + "*"}
            data-tooltip-id="branch_nameTooltip"
            data-tooltip-content={t["Bank Branch"] + "*"}
          />
          <ReactTooltip id="branch_nameTooltip" type="dark" effect="solid" />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="acc_holder_name"
            placeholder={t["Business Account Name"] + "*"}
            data-tooltip-id="acc_holder_nameTooltip"
            data-tooltip-content={t["Business Account Name"] + "*"}
          />
          <ReactTooltip
            id="acc_holder_nameTooltip"
            type="dark"
            effect="solid"
          />
        </div>
        <div className="my-3 col-md-6 col-12">
          <FormikInput
            name="account_number"
            handleOnBlur={async (e) => {
              const { value, name } = e.target;
              setFieldTouched(name, true);
              // console.log("first", value);
              // Call the API to check if the account number exists
              // try {
              //   const response = await Promise.all([
              //     checkApi({
              //       params: { account_number: value },
              //       endpoint: "/onboarding/account_check",
              //     }),
              //   ]);

              //   const [accountCheckResponse = {}] = response;

              //   if (accountCheckResponse?.result?.result?.exists === true) {
              //     // console.log(
              //     //   "check account number response if exists",
              //     //   accountCheckResponse?.result?.result?.exists
              //     // );

              //     setFieldValue("account_number_exist", true);
              //   } else {
              //     setFieldValue("account_number_exist", false);
              //   }
              // } catch (error) {
              //   console.error("Error checking account number:", error);
              // } finally {
              //   handleCloseLoader();
              // }
            }}
            placeholder={t["Account Number"] + "*"}
            data-tooltip-id="account_numberTooltip"
            data-tooltip-content={t["Account Number"] + "*"}
          />
          <ReactTooltip id="account_numberTooltip" type="dark" effect="solid" />
        </div>
        {sessionInfo.isVTEX === true && (
          <div className="my-3 col-md-6 col-12">
            <FormikInput
              name="iban"
              placeholder={t["IBAN Number"] + "*"}
              data-tooltip-id="ibanTooltip"
              data-tooltip-content={t["IBAN Number"] + "*"}
            />
            <ReactTooltip id="ibanTooltip" type="dark" effect="solid" />
          </div>
        )}
      </div>
    </>
  );
}

export default CRBannkAccountStep;
